import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { NotFoundComponent } from './shared/error/notfound/notfound.component';
import { ForbiddenComponent } from './shared/error/forbidden/forbidden.component';
import { CustomPreloadingStrategyService, RouteStrategyType } from './shared/_services/custom-preloading-strategy.service';
import { MaintenanceComponent } from './shared/error/maintenance/maintenance.component';

export interface StrategyRoute extends Route {
  children?: StrategyRoutes;
  data?: {
    [index: string]: string | string[] | boolean;
    routeSectionType?: RouteStrategyType;
    hasAnyPermissions?: boolean;
  };
}

export declare type StrategyRoutes = StrategyRoute[];

const routes: StrategyRoutes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
    data: { routeSectionType: 'preload' }
  },
  {
    path: 'signup',
    loadChildren: () => import('./features/signup/signup.module').then(m => m.SignupModule),
    data: {  title: 'Signup', mode: 'self-serve', routeSectionType: 'lazy'  }
  },
  {
    path: 'pubsignup',
    loadChildren: () => import('./features/signup/signup.module').then(m => m.SignupModule),
    data: {  title: 'Signup', mode: 'managed', routeSectionType: 'lazy'  }
  },
  {
    path: 'googlesignup',
    loadChildren: () => import('./features/signup/signup.module').then(m => m.SignupModule),
    data: {  title: 'Signup', mode: 'google', routeSectionType: 'lazy'  }
  },
  // Errors
  { path: 'error/403', component: ForbiddenComponent, data: { title: 'Forbidden' } },
  { path: 'maintenance', component: MaintenanceComponent },
  {
    path: '',
    loadChildren: () => import('./layout/base_layout.module').then(m => m.BaseLayoutModule),
    data: { routeSectionType: 'preload' }
  },
  // Path for 404, all others routes
  { path: '**', component: NotFoundComponent, data: { title: 'Not found' } }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {  onSameUrlNavigation: 'reload', preloadingStrategy: CustomPreloadingStrategyService  }) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule {
}
